<template>

     <div class="px-6 flex justify-between items-center">
        
        <div class="flex-1 flex justify-center items-center  ">
          <p class="text-2xl font-semibold">Check In</p>
        </div>
      </div>
      <div class="pt-8 flex justify-center items-center flex-col">
        <div class="rounded-full overflow-hidden bg-g300">
          <img src="../../public/asset/people-2.jpg" alt="" class="w-[140px] h-[140px] object-cover">
        </div>

         <h1>Check in success</h1>  
         
        <p class="text-sm font-semibold pt-3">
       
          Welcome Back!, Selamat Bekerja ya !
        </p>
        
         <router-link  to="/"  class="flex-1 py-3 bg-g300 text-white text-center rounded-xl font-medium border border-g300" style="padding: 5px 15px;margin-top:20px;"> Kembali </router-link>

      </div>

</template>